<div class="continuity-planning-step">
  <p class="continuity-planning-intro">{{ introText }}</p>

  <app-chip-group
    [control]="chipsControl"
    [options]="chipOptions"
    [label]="chipsLabel"
  />

  <app-textarea
    [control]="notesControl"
    [label]="notesLabel"
    [placeholder]="notesPlaceholder"
    [required]="false"
  />

  <p class="continuity-planning-reminder">{{ reminderText }}</p>
</div>
